export interface ResponseEnvelope<R> extends Array<R> {
  totalRecords: number;
}

export function makeResponseEnvelope<R>(
  data: R[],
  totalRecords: number = data.length
): ResponseEnvelope<R> {
  // tslint:disable-next-line:prefer-object-spread
  return Object.assign(data, {
    totalRecords
  });
}
